import type { ComponentProps, ReactElement, Ref } from 'react';
import { forwardRef } from 'react';
import type { Except } from 'type-fest';
import { ButtonContent } from './ButtonContent';
import type { BaseButtonProps, ButtonType } from './baseTypes';
import { getClassNames } from './getClassNames';

export interface BaseDivButtonProps extends BaseButtonProps<'div'> {
  type?: Exclude<ButtonType, 'link'>;
  href?: never;
  to?: never;
}

export type DivButtonProps = BaseDivButtonProps & Except<ComponentProps<'div'>, 'ref'>;

/** @deprecated use Button from kitt-universal instead */
export const DivButton = forwardRef(
  (
    {
      children,
      type,
      disabled,
      icon,
      iconPosition = 'left',
      stretch,
      large,
      variant = 'default',
      xLarge,
      onClick,
      className,
      ...props
    }: DivButtonProps,
    ref: Ref<HTMLDivElement>,
  ): ReactElement => {
    return (
      <div
        ref={ref}
        aria-hidden
        className={getClassNames(
          children,
          !!icon,
          iconPosition,
          large,
          xLarge,
          stretch,
          type,
          disabled,
          className,
          variant,
        )}
        role="button"
        tabIndex={0}
        onClick={disabled ? undefined : (onClick as DivButtonProps['onClick'])}
        {...(props as DivButtonProps)}
      >
        <ButtonContent icon={icon} iconPosition={iconPosition}>
          {children}
        </ButtonContent>
      </div>
    );
  },
);
